.chip {
  padding: 4px 10px;
  border: 1.5px solid var(--ink);
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

/* Accent and green keep their colour in both themes, so the text on them
 * stays dark rather than following --ink. */
.COMPLETE {
  background: var(--done);
  color: var(--accent-ink);
}

.PARTIAL {
  background: var(--accent);
  color: var(--accent-ink);
}

.NONE {
  background: var(--surface);
}
